var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse, _path19, _path20, _circle, _path21, _path22, _path23, _path24, _ellipse2, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c7e6db",
    d: "m280.396 118-20 378h172l-20-378z",
    "data-original": "#c7e6db"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1cdc9",
    d: "M376.396 140.548V496h56l-20-378z",
    "data-original": "#b1cdc9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#85ad9f",
    d: "M346.396 419.553a8 8 0 0 1-8-8V158.57a8 8 0 1 1 16 0v252.982a8 8 0 0 1-8 8z",
    "data-original": "#85ad9f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "M346.396 107a8 8 0 0 1-8-8V35.019a8 8 0 1 1 16 0V99a8 8 0 0 1-8 8",
    "data-original": "#3c3c3c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#83969e",
    d: "M376.396 419.553a8 8 0 0 1-8-8V158.57a8 8 0 1 1 16 0v252.982a8 8 0 0 1-8 8z",
    "data-original": "#83969e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#85ad9f",
    d: "M316.396 419.553a8 8 0 0 1-8-8V158.57a8 8 0 1 1 16 0v252.982a8 8 0 0 1-8 8z",
    "data-original": "#85ad9f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#88a9c9",
    d: "M53.59 8v488h180V38z",
    "data-original": "#88a9c9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7994a9",
    d: "M151.368 24.296V496h82.222V38z",
    "data-original": "#7994a9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b6dede",
    d: "M53.59 64h180v56h-180zm0 112h180v56h-180zm0 112h180v56h-180z",
    "data-original": "#b6dede"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1cdc9",
    d: "M151.368 64h82.222v56h-82.222zm0 112h82.222v56h-82.222zm0 112h82.222v56h-82.222z",
    "data-original": "#b1cdc9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d799a",
    d: "M53.59 400h180v56h-180z",
    "data-original": "#5d799a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c5790",
    d: "M178.59 328h200v168h-200z",
    "data-original": "#5c5790"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#444271",
    d: "M261.723 328H378.59v168H261.723z",
    "data-original": "#444271"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6275",
    d: "M295.59 276h184v220h-184z",
    "data-original": "#ff6275"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3c59",
    d: "M411.213 276h68.377v220h-68.377zm-99.623-30h152v30h-152z",
    "data-original": "#ff3c59"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#da3c59",
    d: "M404.396 246h59.194v30h-59.194z",
    "data-original": "#da3c59"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1cdc9",
    d: "M300.396 80h92v38h-92z",
    "data-original": "#b1cdc9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#83969e",
    d: "M300.396 97v21h92v-13z",
    "data-original": "#83969e"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.358,
    cy: 353.248,
    fill: "#369b00",
    "data-original": "#369b00",
    rx: 60.358,
    ry: 83.993
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#92673a",
    d: "M100.569 338.966c-5.474-3.7-12.962-2.034-16.762 3.371l-6.45 9.176v-27.488c0-6.607-5.168-12.275-11.774-12.396-6.73-.124-12.226 5.295-12.226 11.997v175.698A4.676 4.676 0 0 0 58.034 504H72.68a4.676 4.676 0 0 0 4.676-4.676V393.248l26.314-37.435c3.854-5.484 2.475-13.077-3.102-16.846z",
    "data-original": "#92673a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#72523a",
    d: "M117.775 504h-7.118a4.44 4.44 0 0 1-4.441-4.441v-48.055h16v48.055a4.44 4.44 0 0 1-4.441 4.441",
    "data-original": "#72523a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114.216,
    cy: 441.744,
    r: 30.191,
    fill: "#b2bd00",
    "data-original": "#b2bd00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c5790",
    d: "M332.344 305.948h16v24.351h-16zm47.246 0h16v24.351h-16zm0 42.064h16v24.351h-16zm0 42.059h16v24.351h-16zm47.245-84.123h16v24.351h-16zm-94.491 42.065h16v24.35h-16zm0 42.053h16v24.361h-16z",
    "data-original": "#5c5790"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9e9ff",
    d: "M340.344 438h47.246v58h-47.246z",
    "data-original": "#b9e9ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7faff",
    d: "M387.59 438h47.246v58H387.59z",
    "data-original": "#d7faff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5d6bc",
    d: "M249.548 357.307h24.35v16h-24.35zm0 47.246h24.35v16h-24.35zm0 47.245h24.35v16h-24.35zm-40.874-94.491h24.35v16h-24.35zm0 47.246h24.35v16h-24.35zm0 47.245h24.35v16h-24.35z",
    "data-original": "#e5d6bc"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.642,
    cy: 400.053,
    fill: "#83b200",
    "data-original": "#83b200",
    rx: 60.358,
    ry: 65.619
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#72523a",
    d: "M443.868 401.629c-6.73-.124-12.226 5.295-12.226 11.998v86.514a3.86 3.86 0 0 0 3.86 3.859h16.282a3.86 3.86 0 0 0 3.858-3.859v-86.116c0-6.607-5.168-12.275-11.774-12.396",
    "data-original": "#72523a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.d077b7b0c342a4c35a1ae23e019fcafa.svg";
export { ForwardRef as ReactComponent };